import { Licensing } from '@adaptiva/core/licensing';
import { IClassLazyLoader } from '@adaptiva/core/loaders';

export const LAZY_LOADED_CLASSES: IClassLazyLoader[] = [
	{
		product: Licensing.Products.OneSite.PATCH,
		load: () => import('@adaptiva/patching/lazy').then(m => m.PatchingClassLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.PATCH_EXPRESS,
		load: () => import('@adaptiva/patching/lazy').then(m => m.PatchExpressClassLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.ANYWHERE,
		load: () => import('@adaptiva/onesite/lazy').then(m => m.OneSiteClassLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.INTUNE,
		load: () => import('@adaptiva/onesite/lazy').then(m => m.OneSiteIntuneClassLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.VMWARE,
		load: () => import('@adaptiva/onesite/lazy').then(m => m.OneSiteVmwareClassLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.HEALTH,
		load: () => import('@adaptiva/endpoint-health/lazy').then(m => m.EndpointHealthClassLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.WAKE,
		load: () => import('@adaptiva/wake/lazy').then(m => m.OneSiteWakeLoaderModule)
	},
	{
		product: Licensing.Products.AddOns.TENABLE,
		load: () => import('@adaptiva/patching/lazy').then(m => m.TenableLoaderModule)
	},
	{
		product: Licensing.Products.OneSite.INVENTORY,
		load: () => import('@adaptiva/telemetry/lazy').then(m => m.DeviceInventoryClassLoaderModule)
	},
	{
		product: '*',
		load: () => import('./cloud-server-loader.module').then(m => m.CloudServerLoaderModule)
	}
];
